module.exports = {
  hero: {
    title: "Juntos compramos mejor",
    description:
      "Descubre la manera inteligente de comprar por tu celular. Te presentamos el primer Social Shopping, donde todos ahorramos, ganamos e interactuamos para comprar mejor. Explora, comparte, ahorra y recibe tus productos en 48 horas en la puerta de tu casa.",
    bgImage: "img/app-hero-img.png"
  },
  promo: {
    title: "Por qué las marcas aman vender por Frisbee?",
    description:
      "Somos una plataforma flexible, enfocada en tecnología, logística y ventas efectivas por internet. Te damos todas las herramientas para que sigas encantando a tus clientes más fieles.",
    items: [
      {
        title: "Fidelizamos tus Clientes",
        description:
          "Entregamos tus productos dentro de 48 horas, puedes rastrear tus despachos y asegurar que la experiencia de tus clientes sean perfecta.",
        icon: "ti-face-smile text-white"
      },
      {
        title: "Facilitamos tus Ventas y Logística",
        description: "Agrega un canal de ventas importante para tu marca, entregamos directamente a tu cliente y manejamos devoluciones efectivamente. ",
        icon: "ti-stats-up text-white"
      },
      {
        title: "Transformación Digital Efectiva",
        description: "Tu puedes enfocarte en hacer lo que haces mejor, tener los productos que tus clientes aman y nosotros nos enfocamos en tener la mejor experiencia de compra digital.",
        icon: "ti-eye text-white"
      }
    ]
  },
  aboutUs: {
    title: {
      bold: "Use your android or ios device",
      normal: ""
    },
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Clean Design",
        description:
          "Increase sales by showing true dynamics of your website",
        icon: "ti-vector text-white"
      },
      {
        title: "Secure Data",
        description:
          "Build your online store’s trust using Social Proof & Urgency",
        icon: "ti-lock text-white"
      },
      {
        title: "Retina Ready",
        description:
          "Realize importance of social proof in customer’s purchase decision",
        icon: "ti-eye text-white"
      }
    ]
  },
  price: {
    title: "Nuestros Paquetes",
    description:
      "Uniquely maintain efficient expertise whereas cross functional deliverables. Continually leverage other's competitive mind share whereas enabled channels. ",
    packages: [
      {
        price: "$29",
        license: "Starter",
        isFeatured: false,
        features: [
          "5 Despachos Gratis",
          "$2,50 por Despacho Adicional",
          "50 Productos",
          "1 Usuario",
          "Notificaciones y Tracking de Despachos",
          "5 Flash Sales",
          "Reportería de Ventas y Clientes",
          "Soporte Técnico"
        ]
      },
      {
        price: "$49",
        license: "Growth",
        isFeatured: true,
        features: [
          "30 Despachos Gratis",
          "$1,99 por Despacho Adicional",
          "100 Productos",
          "Sincronización de Precios y Stock",
          "5 Usuarios",
          "Roles y Permisos de Acceso",
          "10 Flash Sales",
          "Reportería de Ventas, Productos, Clientes y Visitas",
          "Soporte Técnico Horario Laboral"
        ]
      },
      {
        price: "$250",
        license: "Enterprise",
        isFeatured: false,
        features: [
          "75 Despachos Gratis",
          "$1,50 por Despacho Adicional",
          "Productos Ilimitados",
          "Usuarios Ilimitados",
          "Roles y Permisos de Acceso",
          "Integración con tu ERP",
          "Empaque Personalizado",
          "15 Flash Sales",
          "Reportería Completa y Recomendaciones",
          "CRM Integrado",
          "Soporte Técnico 24/7",
        ]
      }
    ]
  },
  testimonial: {
    title: "What customer say about us",
    description:
      'Rapidiously morph transparent internal or "organic" sources whereas resource sucking e-business. Conveniently innovate compelling internal.',
    comments: [
      {
        name: "Arabella Ora",
        company: "AgencyCo",
        image: "img/client-2.jpg",
        comment:
          "Completely build backend ROI whereas cross-media metrics. Collaboratively deploy customer directed web-readiness via global testing procedures. Appropriately reinvent distributed innovation without proactive catalysts for change. Distinctively."
      },
      {
        name: "John Charles",
        company: "ThemeTags",
        image: "img/client-1.jpg",
        comment:
          "If you can design one thing you can design everything with Front. Just believe it. Collaboratively repurpose performance based e-commerce without cost. It's beautiful and the coding is done quickly and seamlessly."
      },
      {
        name: "Jeremy Jere",
        company: "WorldCheck",
        image: "img/client-3.jpg",
        comment:
          "The template is really nice and offers quite a large set of options. It's beautiful and the coding is done. If you can design one thing you can design everything with Front. Just believe it."
      },
      {
        name: "Ciaran Kierce",
        company: "AppCo",
        image: "img/client-4.jpg",
        comment:
          "I just wanted to share a quick note and let you know that you guys do a really good job. I’m glad I decided to work with you. It’s really great how easy your websites are to update and manage. I never have any problem at all."
      }
    ]
  },
  contact: {
    title: "Contáctanos",
    description:
      "Es muy fácil contactarnos, llámanos si tienes preguntas, necesotas asesoría en el proceso de compra, o si solo quieres hablar con un humano amigable.",

    office: "Headquarters",
    address: "Av Galo Plaza Lasso, Quito Ecuador",
    phone: "+593 963300245",
    email: "contacto@frisbee.com.ec"
  },
  trustedCompany: [
    "img/client-1-color.png",
    "img/client-6-color.png",
    "img/client-3-color.png",
    "img/client-4-color.png",
    "img/client-5-color.png"
  ],
  trustedCompanyGray: [
    "img/client-1-gray.png",
    "img/client-2-gray.png",
    "img/client-3-gray.png",
    "img/client-4-gray.png",
    "img/client-5-gray.png"
  ],
  trustedCompanyAboutUs: {
    title: "Nuestras Marcas Aliadas",
    description: "Encuentra solo las mejores marcas en la App de Frisbee, nos aseguramos de tener productos de calidad, a precios increíbles y con una experiencia de compra fabulosa!",
    companies: [
      "img/client-5-color.png",
      "img/client-1-color.png",
      "img/client-6-color.png",
      "img/client-3-color.png",
      "img/client-4-color.png",
      "img/client-5-color.png",
      "img/client-7-color.png",
      "img/client-2-color.png",
      "img/client-1-color.png",
      "img/client-3-color.png"
    ]
  },
  teamMember: {
    members: [
      {
        name: "Yohio E.",
        designation: "Chief Executive Officer (CEO)",
        image: "img/team-4.jpg",
        linkedin: "",
        twitter: "",
        email: "yenriquez@frisbee.com.ec"
      },
      {
        name: "Nixon A.",
        designation: "Chief Product Officer (CPO)",
        image: "img/team-1.jpg",
        linkedin: "https://www.linkedin.com/in/nixon-alvarado-91391656/",
        twitter: "",
        email: "nalvarado@frisbee.com.ec"
      },
      {
        name: "Sebastián A.",
        designation: "Chief Technology Officer (CTO)",
        image: "img/team-2.jpg",
        linkedin: "https://www.linkedin.com/in/alvaradosebastian/",
        twitter: "",
        email: "sebastian@frisbee.com.ec"
      },
      {
        name: "Carlos Martinez",
        designation: "Senior App Developer",
        image: "img/team-3.jpg",
        linkedin: "https://www.linkedin.com/in/santiago-rend%C3%B3n/",
        twitter: "",
        email: "santiago@frisbee.com.ec"
      },
      {
        name: "Julián A.",
        designation: "Chief Marketing Officer (CMO)",
        image: "img/team-3.jpg",
        linkedin: "",
        twitter: "",
        email: "julian@frisbee.com.ec"
      },
      {
        name: "Nario N.",
        designation: "Director de Logistica",
        image: "img/team-3.jpg",
        linkedin: "",
        twitter: "",
        email: "nnarvaez@frisbee.com.ec"
      },
      {
        name: "Edgar Linares Quintero",
        designation: "Back-end Engineer",
        image: "img/team-3.jpg",
        linkedin: "",
        twitter: "",
        email: "edgar.quintero@frisbee.com.ec"
      },
      {
        name: "Edward Moron",
        designation: "Front-end Engineer",
        image: "img/team-3.jpg",
        linkedin: "",
        twitter: "",
        email: "nnarvaez@frisbee.com.ec"
      }
    ]
  },
  video: {
    link: "https://www.youtube.com/watch?v=9No-FiEInLA"
  }
};
